module.exports = __webpack_public_path__ + "dam/dam-logo.svg";